export const REASSIGNMENT_DISABLED_IN_OPTIONS = {
  STATE_TRANSFER: 'STATE_TRANSFER',
  OOO: 'OOO',
  GENERAL_PATIENT_TRANSFER: 'GENERAL_PATIENT_TRANSFER',
  PERMANENT_REASSIGNMENT: 'PERMANENT',
}

export const REASSIGNMENT_DISABLED_IN_OPTIONS_ARRAY = Object.values(REASSIGNMENT_DISABLED_IN_OPTIONS)

// "Product Dev Team Test Doctor Account" — dev team's test account, excluded from Earnings totals
export const TEST_DOCTOR_ID = '38017300-a001-705b-8fcb-9a3e88afd9ff'